var map = {
	"./icons/black-circle.svg": 826,
	"./icons/black.svg": 827,
	"./icons/black_and_gold.svg": 828,
	"./icons/watercolor_black.svg": 829,
	"./icons/watercolor_white.svg": 830,
	"./icons/white-circle.svg": 831,
	"./icons/white.svg": 832,
	"./icons/white_and_gold.svg": 833,
	"./star-map_backgrounds-black.webp": 834,
	"./star-map_backgrounds-black_and_gold.webp": 835,
	"./star-map_backgrounds-black_circle.webp": 836,
	"./star-map_backgrounds-watercolor_black.webp": 837,
	"./star-map_backgrounds-watercolor_white.webp": 838,
	"./star-map_backgrounds-white.webp": 839,
	"./star-map_backgrounds-white_and_gold.webp": 840,
	"./star-map_backgrounds-white_circle.webp": 841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1365;